/**

    * Application Name: Zevcore unolo Backend
    * Application Version: 1.0
    * Author: Zevcore Private Limited
    * Created Date: 17.05.2023
    * Last Modified Date: 17.05.2023
    * Developer Name: Anand_Krishna

**/

import { url } from "../../../services/url";
import axios from "axios";

// Token
const fetchCredentials = async () => {
  try {
    // Retrieve the credentials
    const credentials = await localStorage.getItem("token");
    if (credentials) {
      return {
        headers: {
          "x-access-token": credentials,
        },
      };
    } else {
      console.log("No credentials stored");
    }
  } catch (error) {
    console.log("Keychain couldn't be accessed!", error);
  }
  return false;
};

const profileUrl = {
  profile_Url: `${url.apiUrl}/user_one`,
  profile_Update_Url: `${url.apiUrl}/user_profile`,
};

// For handle get Location Type data list
export const handleGetOneUser = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.get(profileUrl.profile_Url, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// For handle edit Location Type data list
export const handleEditUser = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.patch(
      profileUrl.profile_Update_Url,
      request,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
